import { createContext, useContext, useState, useMemo } from "react";

const SceneContext = createContext(null);

export const SceneProvider = ({ children }) => {
  const [focus, setFocus] = useState("neutral");

  const value = useMemo(() => ({ focus, setFocus }), [focus]);

  return <SceneContext.Provider value={value}>{children}</SceneContext.Provider>;
};

export const useScene = () => {
  const ctx = useContext(SceneContext);
  if (!ctx) throw new Error("useScene must be used within SceneProvider");
  return ctx;
};
